import { AfterViewInit, Component, Inject, OnDestroy, OnInit, Type, inject } from '@angular/core';
import moment from 'moment';

import { InvestimentsBase } from '../investiments.base';
import { CryptosService } from './cryptos.service';
import { CryptoCreateComponent } from './create/create.component';
import { CryptoModifyComponent } from './modify/modify.component';

@Component({
  selector: 'app-cryptos',
  standalone: false,
  templateUrl: './cryptos.component.html',
  styleUrl: './cryptos.component.scss'
})
export class CryptosComponent extends InvestimentsBase<CryptoCreateComponent, CryptoModifyComponent> implements AfterViewInit {

  override service = inject(CryptosService)

  override list : any = {
    columns: [
      'share', 'side', 'amount', 'price', 'tax', 'total', 'usdBrl', 'btcUsd', 'date', 'action'
    ],
    data: []
  }
  
  constructor() {
    super(CryptoCreateComponent, CryptoModifyComponent)

  }

  async ngAfterViewInit(): Promise<void> {
    console.error('CryptosComponent -> ngAfterViewInit')

    console.log("listCryptos: ", this.list.data)
  }

  override async evaluate(r: any, mode:string='add'):Promise<boolean> {
    // console.error('CryptosComponent -> evaluate', r)
    
    console.error('CryptosComponent -> evaluate', r.share)

    const exists = this.list.data.filter((i: any)=>{ return i.id == r.id })[0]
    console.error('CryptosComponent -> evaluate', 'exists', exists?.id == r.id)

    var list:any[] = [...this.list.data]
    if(exists==undefined)
      list.push(r)
    if(exists!=undefined)
      list = [...this.list.data.filter((i: any)=>{ return i.id != r.id }), r]

    let amount:number = 0;
    await list.forEach((e:any) => {      
      if(e.share == r.share) {
        if(e.side == 'BUY')
          amount = amount + parseFloat(e.amount)
        
        if(e.side == 'SELL')
          amount = amount - parseFloat(e.amount)
      }
    })

    console.warn('CryptosComponent -> evaluate', r.share, amount, amount >= 0)
    // Tolerance for floating point residue on fractional amounts
    return await amount >= -1e-9
  }
  
}
